import { render, staticRenderFns } from "./MenuYellowQRIcon.vue?vue&type=template&id=4f6eb31b&"
import script from "./MenuYellowQRIcon.vue?vue&type=script&lang=ts&"
export * from "./MenuYellowQRIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports